import { PropsWithChildren, useEffect } from 'react';
import { CurrencyProvider, type Currency } from '@/context/CurrencyContext';
import { initializeUserLanguage } from '@/i18n';

interface AppWrapperProps extends PropsWithChildren {
  initialCurrency?: Currency;
  userId?: number;
}

export function AppWrapper({ children, initialCurrency = 'EUR', userId }: AppWrapperProps) {
  useEffect(() => {
    // Restore user's language preference from localStorage
    initializeUserLanguage(userId);
  }, [userId]);

  return (
    <CurrencyProvider initialCurrency={initialCurrency}>
      {children}
    </CurrencyProvider>
  );
}
